import * as React from 'react';
import { observer } from 'mobx-react';
import { motion } from 'framer-motion';

import Menu from '../Menu';

import { useAnimation } from './hooks';

import './MobileMenu.modules.scss';

const MobileMenu: React.FC = () => {
  const { ref } = useAnimation();

  return (
    <motion.div ref={ref} styleName="mobile-menu">
      <Menu styleName="mobile-menu__content" />
    </motion.div>
  );
};

export default observer(MobileMenu);
